/**
 * Stack routes of the native screens added by the `system` admin-module group.
 * Registered by AppNavigator in the management stack.
 */
import lazyScreen from '../../components/lazyScreen';

// Example: {name: 'MyScreen', component: lazyScreen(() => import('../../screens/adminModules/system/MyScreen'))}
const ROUTES = [];

export default ROUTES;
